export const BRACKET_TEAM_NUMBER_OPT = [4, 8, 16, 32, 64, 128, 256, 512];
export const DOUBLE_BRACKET_TEAM_NUMBER_OPT = [32];
